import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LoadingController, Platform } from "ionic-angular";
import { AppSettings } from './app-settings'
// import { HttpParams, HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Http, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';


@Injectable()
export class ServerService {
    adruncount: any = 0;
    adruncount2: any = 0;
    constructor(public loadingCtrl: LoadingController,
        private plat: Platform,
        private http: Http) {
    }


    auth(url, email, password) {
        try {
            let body = new FormData();
            body.append("email", email);
            body.append("password", password);
            body.append("remember", "true");
            return this.http.post(AppSettings.ROO_API + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
        }
    }

    getEvents(url, params) {
        try {


            var headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append("Authorization", localStorage.getItem("token"));
            // headers.append("Debug", "1");


            let body = JSON.stringify({
                start: params['start'],
                end: params['end'],
                view: params['view'],
                // Debug: '1'
            });


            return this.http.post(AppSettings.ROO_API + '' + url, body, { headers: headers }).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
        }
    }


    sendPostParams(url, params) {
        try {


            var headers = new Headers();
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
            headers.append("Authorization", localStorage.getItem("token"));
            // headers.append("Debug", "1");


            let urlSearchParams = new URLSearchParams();


            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const value = params[key];
                    urlSearchParams.append(key, value);
                }
            }

            let body = urlSearchParams.toString();

            return this.http.post(AppSettings.ROO_API + '' + url, body, { headers: headers }).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
        }
    }


    sendPostRoom(url, params, relate_events_rooms) {
        try {


            var headers = new Headers();
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
            headers.append("Authorization", localStorage.getItem("token"));
            // headers.append("Debug", "1");

            // let urlSearchParams = new URLSearchParams();


            // for (const key in params) {
            //     if (params.hasOwnProperty(key)) {
            //         const value = params[key];
            //         urlSearchParams.append(key, value);
            //     }
            // }

            // urlSearchParams.append("relate_events_rooms", relate_events_rooms);
            // let body = urlSearchParams;


            // console.log("body:", body);
            console.log("body params:", params);

            return this.http.post(AppSettings.ROO_API + '' + url, params, { headers: headers }).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
        }
    }

    getUnavailableRooms(url, params) {
        try {


            var headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append("Authorization", localStorage.getItem("token"));

            let body = JSON.stringify({
                start: params['start'],
                end: params['end'],
            });

            return this.http.post(AppSettings.ROO_API + '' + url, body, { headers: headers }).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
        }
    }


}




// WEBPACK FOOTER //
// ./src/services/server-service.ts